import {
  STICKY_FOOTER_BUTTON_VIEW, STICKY_FOOTER_EMAIL_VIEW,
  STICKY_FOOTER_TOGGLE_TRIGGER,
} from './types';

export const triggerStickyFooterButtonIsViewed = () => ({
  type: STICKY_FOOTER_BUTTON_VIEW,
});

export const triggerStickyFooterEmailIsViewed = (isUserOptedOutFromEmail) => ({
  type: STICKY_FOOTER_EMAIL_VIEW,
  isUserOptedOutFromEmail,
});

export const triggerStickyFooterButtonIsToggledGaEvent = (stickyFooterVendorType, isExpanded) => ({
  type: STICKY_FOOTER_TOGGLE_TRIGGER,
  stickyFooterVendorType,
  isExpanded,
});
